import { useMemo } from "react";
import { useHistory } from "../../hooks/useHistory";
import { HomeIcon, LearningIcon } from "../../icons";

export interface IMenuOption {
  text: string;
  Icon: JSX.Element;
  path?: string;
  menu?: string;
  divider?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  joyRideTarget?: string;
}

export const options: IMenuOption[] = [
  {
    text: "Home",
    Icon: <HomeIcon />,
    path: "/dashboard",
    menu: "main",
    joyRideTarget: "homeStep",
  },
  {
    text: "Learning",
    Icon: <LearningIcon />,
    path: "/learning",
    menu: "main",
    joyRideTarget: "learningStep",
  },
];

export const useMenuOptions = () => {
  const history = useHistory();

  const menuOptions = useMemo(() => {
    options.forEach((option) => {
      option.onClick = () => {
        if (option.path)
          history.push({
            pathname: `/participant${option.path}`,
          });
      };
    });
    return options;
  }, [history]);

  return menuOptions;
};
